import React, { FC, ReactElement } from 'react';
import './OfferAvailabilityHeader.scss';
import withLocalization from '../hoc/withLocalization';

const OfferAvailabilityHeader: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  return (
    <>
      <div className="dateHeaderWrapper">
        <h3 className="headBaskerville">{localize('preview-sales-engine.static-content.copy.calendar-page.header')}</h3>
      </div>
    </>
  );
};
export default withLocalization(OfferAvailabilityHeader);
